export default "__VITE_ASSET__DfiXXs0y__"